<div class="modal-header" [class.modal-header--with-subtitle]="modalSubtitle">
  <div class="modal-heading">
    <h5 class="modal-title">{{ modalTitle || ('assetShared.createMaintenance.create' | transloco) }}</h5>

    @if (modalSubtitle) {
      <span class="modal-subtitle">{{ modalSubtitle }}</span>
    }
  </div>

  <button type="button" class="btn-close" (click)="closeModal()">
    <i class="ph ph-x"></i>
  </button>
</div>

<div class="modal-body" *transloco="let t; prefix: 'assetShared.createMaintenance'">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <!-- Asset -->
    <div class="form-group">
      @if (isAssetLocked) {
        <label>{{ t('asset') }} <span class="required">*</span></label>
        <input type="text" class="form-control locked-asset" [value]="selectedAsset" readonly disabled />
      } @else {
        <app-asset-search-dropdown
          [accountIds]="accountIds"
          [selectedAssetId]="form.get('assetId')?.value"
          [selectedAssetName]="selectedAsset"
          [dropdownMaxHeight]="'270px'"
          [showRequiredError]="!!(form.get('assetId')?.invalid && form.get('assetId')?.touched)"
          (assetSelected)="onAssetSelect($event)">
        </app-asset-search-dropdown>
      }
    </div>

    <!-- Service Type + Maintenance Reason -->
    <div class="form-row">
      <div class="form-group half-width">
        <label>{{ t('serviceType') }} <span class="required">*</span></label>

        <div ngbDropdown class="custom-dropdown" [autoClose]="true">
          <button type="button" class="btn form-control dropdown-toggle" ngbDropdownToggle>
            <div class="d-flex flex-row justify-content-between dropdown-inner">
              <span class="align-middle" [class.dropdown-placeholder]="!selectedMaintenanceType">{{ maintenanceTypeLabel }}</span>
              <i class="ph ph-caret-down lh-base"></i>
            </div>
          </button>

          <div ngbDropdownMenu>
            <div class="d-flex flex-column">
              @for (t of maintenanceTypes; track t.value) {
                <button type="button" class="btn btn-outline" ngbDropdownItem (click)="onMaintenanceTypeSelect(t.value, $event)">
                  {{ t.label }}
                </button>
              }
            </div>
          </div>
        </div>

        @if (form.get('maintenanceType')?.invalid && form.get('maintenanceType')?.touched) {
          <div class="error-message">{{ t('serviceTypeRequired') }}</div>
        }
      </div>

      <div class="form-group half-width">
        <label>{{ t('maintenanceReason') }} <span class="required">*</span></label>

        <div ngbDropdown class="custom-dropdown reason-dropdown" [autoClose]="true">
          <button type="button" class="btn form-control dropdown-toggle" ngbDropdownToggle>
            <div class="d-flex flex-row justify-content-between dropdown-inner">
              <span class="align-middle" [class.dropdown-placeholder]="!selectedMaintenanceReason">{{ maintenanceReasonLabel }}</span>
              <i class="ph ph-caret-down lh-base"></i>
            </div>
          </button>

          <div ngbDropdownMenu>
            <div class="d-flex flex-column">
              @if (isLoadingReasons) {
                <div class="dropdown-loading">
                  <span class="spinner-border spinner-border-sm"></span>
                  <span>{{ t('loadingReasons') }}</span>
                </div>
              } @else if (maintenanceReasons.length === 0) {
                <div class="dropdown-loading">
                  <span>{{ t('noReasonsFound') }}</span>
                </div>
              } @else {
                @for (r of maintenanceReasons; track r.id) {
                  <button type="button" class="btn btn-outline" ngbDropdownItem (click)="onMaintenanceReasonSelect(r, $event)">
                    {{ r.localizedName || r.name }}
                  </button>
                }
              }
            </div>
          </div>
        </div>

        @if (form.get('maintenanceReason')?.invalid && form.get('maintenanceReason')?.touched) {
          <div class="error-message">{{ t('maintenanceReasonRequired') }}</div>
        }
      </div>
    </div>

    <!-- Scheduled Date + Priority Level -->
    <div class="form-row">
      <div class="form-group half-width">
        <app-flatpickr-date-picker
          [label]="t('dueDate')"
          [(value)]="dueDate"
          (valueChange)="onDueDateChange($event ?? '')"
          [minDate]="'today'"
          [altFormat]="'d/m/Y'"
          [placeholder]="'dd/mm/yyyy'"
          [required]="true">
        </app-flatpickr-date-picker>

        @if (form.get('dueDate')?.invalid && form.get('dueDate')?.touched) {
          <div class="error-message">{{ t('dueDateRequired') }}</div>
        }
      </div>

      <div class="form-group half-width">
        <label>{{ t('priorityLevel') }} <span class="required">*</span></label>

        <div ngbDropdown class="custom-dropdown" [autoClose]="true">
          <button type="button" class="btn form-control dropdown-toggle" ngbDropdownToggle>
            <div class="d-flex flex-row justify-content-between dropdown-inner">
              <span class="align-middle" [class.dropdown-placeholder]="!selectedPriorityLevel">{{ priorityLevelLabel }}</span>
              <i class="ph ph-caret-down lh-base"></i>
            </div>
          </button>

          <div ngbDropdownMenu>
            <div class="d-flex flex-column">
              @for (p of priorityLevels; track p.value) {
                <button type="button" class="btn btn-outline" ngbDropdownItem (click)="onPriorityLevelSelect(p.value, $event)">
                  {{ p.label }}
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Required Parts -->
    <!-- <div class="form-group">
      <label>Required Parts</label>

      <div class="parts-display-area" (click)="openSelectPartsModal()">
        <div class="chips-wrapper">
          @if (selectedParts.length === 0) {
            <span class="placeholder-text">Select required parts</span>
          }

          @for (part of selectedParts; track part) {
            <span class="part-chip">
              {{ part }}
              <button type="button" class="chip-remove" (click)="removePart(part, $event)">
                <i class="ph ph-x"></i>
              </button>
            </span>
          }

          <button type="button" class="part-chip chip-add" aria-label="Add required part" (click)="openSelectPartsModal(); $event.stopPropagation()">
            <i class="ph ph-plus"></i>
          </button>
        </div>

        <i class="ph ph-caret-down dropdown-caret"></i>
      </div>
    </div> -->

    <!-- Task Description -->
    <div class="form-group">
      <label>{{ t('taskDescription') }}</label>
      <textarea
        class="form-control textarea"
        formControlName="taskDescription"
        rows="3"
        [placeholder]="t('taskDescriptionPlaceholder')"></textarea>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button type="button" class="cancel-btn" (click)="onCancel()" [disabled]="isLoading">{{ 'common.cancel' | transloco }}</button>

      <button type="submit" class="add-btn" [disabled]="isLoading || form.invalid">
        @if (isLoading) {
          <span class="spinner-border"></span>
        }
        @if (!isLoading) {
          <span>{{ t('create') }}</span>
        }
      </button>
    </div>
  </form>
</div>